module.exports = __webpack_public_path__ + "static/media/no-theme-status.8c598254.png";